import {
  apiFrontendServiceLandingCountryspecificRetrieve,
  getApiFrontendServiceLandingCountryspecificRetrieveQueryKey,
  useApiFrontendServiceLandingCountryspecificRetrieve,
} from '@rover/rsdk/src/apiClient/latest/api-frontend-service-landing-countryspecific-retrieve';
import {
  apiFrontendServiceLandingRetrieve,
  getApiFrontendServiceLandingRetrieveQueryKey,
  useApiFrontendServiceLandingRetrieve,
} from '@rover/rsdk/src/apiClient/latest/api-frontend-service-landing-retrieve';
import type { LocalizedBrandService } from '@rover/rsdk/src/apiClient/latest/model/localizedBrandService';
import { CountryUrlPrefix, US_COUNTRY_URL_PREFIX } from '@rover/utilities/roverGeo.constants';

export function getServiceLandingFetchArgs(
  countryUrlPrefix: string,
  serviceLandingSlug: string
): {
  queryKey: ReturnType<
    | typeof getApiFrontendServiceLandingCountryspecificRetrieveQueryKey
    | typeof getApiFrontendServiceLandingRetrieveQueryKey
  >;
  queryFn: () => ReturnType<
    | typeof apiFrontendServiceLandingCountryspecificRetrieve
    | typeof apiFrontendServiceLandingRetrieve
  >;
} {
  const isCountrySpecific = countryUrlPrefix !== US_COUNTRY_URL_PREFIX;
  return isCountrySpecific
    ? {
        queryKey: getApiFrontendServiceLandingCountryspecificRetrieveQueryKey(
          countryUrlPrefix,
          serviceLandingSlug
        ),
        queryFn: () =>
          apiFrontendServiceLandingCountryspecificRetrieve(countryUrlPrefix, serviceLandingSlug),
      }
    : {
        queryKey: getApiFrontendServiceLandingRetrieveQueryKey(serviceLandingSlug),
        queryFn: () => apiFrontendServiceLandingRetrieve(serviceLandingSlug),
      };
}

const useServiceLanding = (
  countryUrlPrefix: CountryUrlPrefix,
  serviceLandingSlug: string
): ReturnType<
  | typeof useApiFrontendServiceLandingCountryspecificRetrieve<LocalizedBrandService>
  | typeof useApiFrontendServiceLandingRetrieve<LocalizedBrandService>
> => {
  const isCountrySpecific = countryUrlPrefix !== US_COUNTRY_URL_PREFIX;

  const countrySpecificServiceLanding = useApiFrontendServiceLandingCountryspecificRetrieve(
    countryUrlPrefix,
    serviceLandingSlug,
    {
      query: { enabled: isCountrySpecific },
    }
  );
  const nonCountrySpecificServiceLanding = useApiFrontendServiceLandingRetrieve(
    serviceLandingSlug,
    {
      query: { enabled: !isCountrySpecific },
    }
  );
  return isCountrySpecific ? countrySpecificServiceLanding : nonCountrySpecificServiceLanding;
};

export default useServiceLanding;
